export default __webpack_public_path__ + "static/media/android-808-surf-tracker.56539e5c.png";